import {IconButton, Paper, Typography} from "@material-ui/core";
import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import VmtLabels from "./VmtLabels";
import Grid from "@material-ui/core/Grid";
import FaqFeedback from "../FaqFeedback";
import EditIcon from "@material-ui/icons/Edit";
import Link from "@material-ui/core/Link";
import _ from "lodash";
// import Button from "@material-ui/core/Button";
// import {Feedback, FileCopyOutlined} from "@material-ui/icons";
import {FileCopyOutlined} from "@material-ui/icons";
import DeleteFaqButton from "../../../components/Button/DeleteFaqButton";
import VmtTree from "../../../components/TreeView/VmtTree";
import useCountryAxiosInstance from "../../../hooks/useCountryAxiosInstance";

const useStyles = makeStyles(() => ({
  vmtLabels: {
    color: '#5d9d52'
  },
  mainPaper: {
    marginTop: "10px",
    marginBottom: 10,
    padding: 15
  },
  img: {
    'max-width': "100%",
    'max-height': "100%",
  },
  vmtLinks: {
    marginRight: '5px',
    marginLeft: '5px'
  }
}));


function FaqDetailView({
                         detailedFaq,
                         triplets,
                         setScrollToObject,
                         vmtSelection,
                         setDetailedFaq,
                         setEditableFaq,
                         toggleNewFaqDialog,
                         toggleTicketDialog,
                         setNavigationStatus,
                         fetchFaqs,
                         isAdmin,
                         userData,
                         openAlert
                       }) {


  const classes = useStyles();
  const apiRequest = useCountryAxiosInstance();
  //Sorting the triplets array by vertical -> macrotema -> tema
  // to then generate tree based on changes
  triplets = triplets.filter(function (el) {
    return el.vertical !== ''
  }).sort(function (a, b) {
    return a.vertical.localeCompare(b.vertical) ||
      a.macrotema.localeCompare(b.macrotema) ||
      a.tema.localeCompare(b.tema);
  });

  const countView = async () => {
    console.log('updating views counter and last_update_views_ts...');
    let updateData = {
      "script": {
        "source": "ctx._source.views += params.count;ctx._source.last_update_views_ts = params.last_update_views_ts",
        "lang": "painless",
        "params": {
          "count": 1,
          "last_update_views_ts": +new Date()
        }
      }
    }


    apiRequest.post(`/assistant/update_with_script`, {
      "doc_id": detailedFaq._id,
      "doc_script": updateData
    }).catch((err) => {
      console.error("Error when updating feedback count", err)
    })

  }

  function isValidHttpUrl(riferimento) {
    let url;

    try {
      url = new URL(riferimento);
    } catch (_) {
      return riferimento;
    }

    if (url.protocol === "http:" || url.protocol === "https:") {
      return (<Link className={classes.vmtLinks}
                    target='_blank'
                    rel="noopener noreferrer"
                    href={riferimento}>
        Link
      </Link>)
    }
  }

  const _onDelete = async (detailedFaq) => {

    apiRequest.delete('/assistant/delete', {"data": {"doc_id": detailedFaq._id}})
      .then(() => {
        setNavigationStatus('home');
        fetchFaqs();
        openAlert("success", "Domanda cancellata con successo")
      }).catch((err) => {
      console.error("Error when fetching faqs", err)

      openAlert("error", "Impossibile elminare la domanda!");
    });


  }

  useEffect(() => {
    countView()
  }, [detailedFaq]); // eslint-disable-line react-hooks/exhaustive-deps

  const isMobile = window.innerWidth < 500;
  const mainWidth = isMobile ? 12 : 9;

  return (
    <>
      <Grid container>
        {!isMobile &&
        <Grid item xs={3}>
          <VmtTree
            detailedFaq={detailedFaq}
            triplets={triplets}
            vmtSelection={vmtSelection}
            setScrollToObject={setScrollToObject}
            setDetailedFaq={setDetailedFaq}
            setNavigationStatus={setNavigationStatus}
            userData={userData}
          />
        </Grid>
        }
        <Grid item xs={mainWidth}>
          <Paper className={classes.mainPaper}>
            {isAdmin &&
            <>
              <Grid container>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => {
                      console.log('DETAIL FAQ VIEW setting editable faq', detailedFaq);
                      setEditableFaq(detailedFaq);
                      toggleNewFaqDialog();
                    }}
                    color="primary"
                  >
                    <EditIcon/>
                  </IconButton>
                </Grid>
                <Grid item xs={8}>
                  <div style={{textAlign: "center"}}>
                    {detailedFaq._id}
                    <IconButton onClick={() => {
                      navigator.clipboard.writeText(detailedFaq._id).then(
                        openAlert("success", "Codice domanda copiato")
                      )
                    }}>
                      <FileCopyOutlined/>
                    </IconButton>

                  </div>
                </Grid>
                <Grid item xs={2}>
                  <DeleteFaqButton onDelete={() => _onDelete(detailedFaq)}/>
                </Grid>
              </Grid>
            </>
            }
            <Typography variant='h6' style={{marginBottom: 10}}>
              {detailedFaq._source.domanda}
            </Typography>
            <VmtLabels
              vertical={detailedFaq._source.vertical}
              macrotema={detailedFaq._source.macrotema}
              tema={detailedFaq._source.tema}
              setScrollToObject={setScrollToObject}
              setDetailedFaq={setDetailedFaq}
              vmtSelection={vmtSelection}
              setNavigationStatus={setNavigationStatus}
            />
            <div
              style={{marginTop: 10}}
              dangerouslySetInnerHTML={{
                __html: detailedFaq._source.html_risposta?.replaceAll('<img ', '<img style="max-width: 100%"')
                  .replaceAll('<a', '<a target="_blank"')
              }}
            />
            {isValidHttpUrl(detailedFaq._source.riferimenti) &&
            <Typography variant='caption'>
              <b>Riferimento:</b> {isValidHttpUrl(detailedFaq._source.riferimenti)}
            </Typography>
            }
            <FaqFeedback detailedFaq={detailedFaq} toggleTicketDialog={toggleTicketDialog}/>
            <div style={{textAlign: "center"}}>
              {/*<Button color="primary" variant="contained" style={{marginTop: 25, fontSize: 11}} startIcon={<Feedback/>}*/}
              {/*        onClick={() => {*/}
              {/*          toggleTicketDialog(detailedFaq)*/}
              {/*        }}*/}
              {/*>*/}
              {/*  Apri una segnalazione su questa domanda*/}
              {/*</Button>*/}
            </div>
          </Paper>
        </Grid>
      </Grid>
    </>
  )
}

export default React.memo(FaqDetailView, (props, nextProps) => {
  // Render component only when users changes
  return _.isEqual(props.detailedFaq, nextProps.detailedFaq);
})